import { ToastProps } from '@radix-ui/react-toast';
import { cva } from 'cva';
// https://www.figma.com/file/bTl1BBi1Bh0ECdgyWX8GAS/Components?type=design&node-id=281-4636&mode=design&t=RufRmJAttZWOqOCd-0

export type SnackBarVariant = 'default' | 'info' | 'success' | 'warning' | 'error';
export type SnackBarProps = {
  variant?: SnackBarVariant;
  showIcon?: boolean;
  content: string;
  label?: string;
  duration?: number;
  className?: string;
  onClick?: () => void;
} & ToastProps;

export const snackBarVariants = cva('w-full rounded-12 p-12', {
  variants: {
    variant: {
      default: 'bg-color-background-secondary',
      info: 'bg-color-background-info',
      success: 'bg-color-background-success',
      warning: 'bg-color-background-warning',
      error: 'bg-color-background-error',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});
